"use client";

import Link from "next/link";
import { cn } from "@/lib/utils";

export default function FloatingEnquiryButton({
  href,
  label,
  className,
}: {
  href: string;
  label: string;
  className?: string;
}) {
  return (
    <div className={cn("fixed bottom-6 left-6 z-[60]", className)}>
      <Link
        href={href}
        className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-black/60 px-5 py-3 text-xs tracking-[0.18em] uppercase text-white backdrop-blur-xl hover:bg-black/75 transition-colors"
      >
        {label}
        <span aria-hidden>↗</span>
      </Link>
    </div>
  );
}